module.exports = __webpack_public_path__ + "img/bgr.cb21c040.jpg";